import {Locale} from '@aboutyou/config';

// This should be moved to the backend at some point.
// Implemented in the frontend for now not the create a backend dependency.
export const codCountries: Locale[] = [
  Locale.pl_PL,
  Locale.cs_CZ,
  Locale.sk_SK,
  Locale.hu_HU,
  Locale.ro_RO,
  Locale.sl_SI,
  Locale.lv_LV,
  Locale.lt_LT,
  Locale.et_EE,
  Locale.hr_HR,
  Locale.bg_BG,
  Locale.it_IT,
  Locale.es_ES,
  Locale.pt_PT,
  Locale.el_GR,
  Locale.ar_SA,
  Locale.en_SA,
  Locale.el_CY,
  Locale.fr_LU,
  Locale.ru_EE,
  Locale.ru_LV,
];

export const verifyAsCashOnDeliveryCountry = (locale: Locale) => {
  return codCountries.includes(locale);
};
